import Vue from 'vue';
import organizationSettingsTransformer from './../../transformers/organizationSettings';
import store from './../../store';

const success = ({ data }, resolve) => {
  store.dispatch('getOrganizationSettings', organizationSettingsTransformer.fetch(data));

  resolve(organizationSettingsTransformer.fetch(data));
};

const failed = () => {};

export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('organization_settings')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/organizationSettings/show.js